module.exports = __webpack_public_path__ + "img/3-1.8e570542.svg";